import { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useServerContext, useOffers, useUserData } from "src/hooks/redux";
import {
  Offer,
  ServerContextState,
} from "src/utils/redux/slices/serverContext";
import { shuffleArray } from "src/utils/arrayMethods";
import {
  updateShippingInfoError,
  updateShippingInfo,
  updateShippingStatus,
  updatePurchasedPlans,
} from "src/utils/redux/slices/offers";

export const getSingleAddOns = (serverContext: ServerContextState) => {
  const { offers } = serverContext;
  return offers["hw-addons-baseline"]?.single || [];
};

const getShuffledAddOns = (serverContext: ServerContextState) => {
  const { offers } = serverContext;
  return shuffleArray(offers["hw-baseline-addons-store"]?.store || []);
};

export const useAddOnsContext = () => {
  const serverContext = useServerContext();
  const userData = useUserData();

  const [addOns, setAddOns] = useState<Offer[]>([]);
  const singleAddons = getSingleAddOns(serverContext);

  useEffect(() => {
    const shuffledAddOns = getShuffledAddOns(serverContext);
    setAddOns(shuffledAddOns);
  }, [serverContext]);

  const offers = useOffers();
  const dispatch = useDispatch();

  const setShippingInfo = useCallback(
    (shippingInfo) => {
      dispatch(updateShippingInfo(shippingInfo));
    },
    [dispatch]
  );

  const setShippingInfoError = (shippingInfoError) => {
    dispatch(updateShippingInfoError(shippingInfoError));
  };

  const setShippingStatus = (shippingStatus) => {
    dispatch(updateShippingStatus(shippingStatus));
  };

  const setPurchasedPlans = (purchasedPlans) => {
    dispatch(updatePurchasedPlans(purchasedPlans));
  };

  const { shippingInfo, shippingStatus, shippingInfoError, purchasedPlans } =
    offers;

  const name = userData?.name;
  useEffect(() => {
    if (name) {
      const nameSplit = name.split(" ");
      const firstName = nameSplit[0];
      const lastName = nameSplit.slice(1).join(" ");

      setShippingInfo({
        ...shippingInfo,
        firstName,
        lastName,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, setShippingInfo]);

  return {
    addOns,
    singleAddons,
    shippingInfo,
    setShippingInfo,
    shippingInfoError,
    setShippingInfoError,
    shippingStatus,
    setShippingStatus,
    setPurchasedPlans,
    purchasedPlans,
  };
};
